// extracted by mini-css-extract-plugin
export var alignCenter = "_c4-d";
export var bannerShown = "_c4-6";
export var buttonContent = "_c4-0";
export var cardList = "_c4-1";
export var centerContent = "_c4-2";
export var chevron = "_c4-3";
export var closePanelButton = "_c4-k";
export var conversationContextContainer = "_c4-l";
export var conversationDetailContainer = "_c4-4";
export var detailWrapper = "_c4-7";
export var dropdownButton = "_c4-e";
export var dropdownTitle = "_c4-9";
export var fullHeight = "_c4-5";
export var hidden = "_c4-a";
export var icon = "_c4-b";
export var mergeSuggestionWrapper = "_c4-m";
export var panel = "_c4-i";
export var portalButtonsWrapper = "_c4-c";
export var right = "_c4-j";
export var tableSummaryContainer = "_c4-8";
export var tableSummaryHeader = "_c4-g";
export var threeDotsButton = "_c4-f";
export var wide = "_c4-h";